import React from 'react';
import { IMG_BASE_URL } from '../Helpers';
import { getDiscountedPrice } from '../Utils';
export default function BookGrid({ books, onViewBook, onlyImage = false }) {

    const handleViewBook = (book) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        onViewBook(book);
    };

    return (
        <>
            <div className={onlyImage ? "" : "col mb-5"} key={books.book_id} onClick={() => handleViewBook(books)}>
                <div className="card h-100">
                    <img className="card-img-top" src={IMG_BASE_URL + "books/" + books.image} alt="..." />
                    {!onlyImage && (
                        <>
                            <div className="card-body p-4">
                                <div className="text-center">
                                    <h5 className="fw-bolder book-title">{books.book_name}</h5>
                                    <div className="price-container">
                                        <span className="price-original">&#8377; {books.mrp}</span>
                                        <span className="price-discounted">&#8377; {getDiscountedPrice(books.mrp, books.discount_percent).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer p-4 pt-0 border-top-0 bg-transparent">
                                <div className="text-center">
                                    <button className="btn btn-outline-dark mt-auto btn-view-options mt-auto" onClick={() => handleViewBook(books)}>
                                        Buy Now
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
